var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h4v4H0V0zm6 0h4v4H6V0zm10 0h-4v4h4V0zm-4 6h4v4h-4V6zm4 6h-4v4h4v-4zM6 12h4v4H6v-4zm-2 0H0v4h4v-4zM0 6h4v4H0V6zm10 0H6v4h4V6z",
    fill: "#000"
  })));
}
export default SvgMediumLayout;